export enum EConversationType {
  PRIVATE = 1,
  GROUP = 2
}

export enum EMessageType {
  TxtMsg = 1,
  ImgMsg = 2,
  SystemMsg = 3
}
